import React from 'react';
import { Box } from '@mui/material';
import '../../shared/styles.css'

const SpaceSection = (props) => {
    const { contentData } = props;
    const { height, backgroundColor } = contentData || {};

    return (
        <Box
            width="100%"
            style={{backgroundColor: backgroundColor || "transparent", height: height ? `${height}px` : '10px'}}>
        </Box>
    );
};

export default SpaceSection;